import { concat, prop } from 'ramda'
import { write, utils } from 'xlsx'
import { getList } from '@/api/springexam/springexamuser'
import { notify } from '@/utils/notification'
import { download } from '@/utils/download'
import { Config, Column, Params } from '@/components/table'
import { SpringExamUser, SpringExam } from '@/models/springexam/SpringExam'
import { ExamRoom } from '@/models/exam/room'

const SHEET = '选考试结果'
const BOOK_TYPE = 'xlsx'
const COLUMNS: Column<SpringExamUser>[] = [
  { prop: 'name', label: '姓名' },
  { prop: 'bmh', label: '春考报名号' },
  { prop: 'sfzh', label: '身份证号' },
  { prop: 'major1', label: '报考专业1' },
  { prop: 'major2', label: '报考专业2' },
  { prop: 'selectExamTime1', label: '专业1选择考试时间' },
  { prop: 'selectExamTime2', label: '专业2选择考试时间' },
  { prop: 'selectSkill1', label: '专业1选择才艺展示项' },
  { prop: 'selectSkill2', label: '专业2选择才艺展示项' }
]

const fetchList = async (id: string, limit: number, offset: number) => {
  try {
    return await getList(id, limit, offset)
  } catch (e) {
    notify('获取列表失败', e)
    return null
  }
}

const fetchAllList = async (id: string) => {
  const data = await fetchList(id, 99999, 0)
  return data ? data.rows : []
}

const toAoa = (row: any) => COLUMNS.map((col: any) => prop(col.prop, row))

const fetchAllListWithFormat = async (id: string) => {
  const data = await fetchAllList(id)
  return data
}

/**
 * 下载选考试结果
 * @param id 考试ID
 */
export const downloadExcel = async (id: string, data?: SpringExamUser[]) => {
  try {
    notify(`正在下载: ${SHEET}, 请耐心等待`)
    const rows = data || ((await fetchAllListWithFormat(id)) as any[])
    const aoa = concat([COLUMNS.map((a: any) => a.label)], rows.map(toAoa))
    const workbook = utils.book_new()
    workbook.SheetNames[0] = SHEET
    workbook.Sheets[SHEET] = utils.aoa_to_sheet(aoa)
    const file = write(workbook, { type: 'array', bookType: BOOK_TYPE })
    const blob = new Blob([file])
    const hash = new Date().toLocaleString()
    download(blob, `${SHEET}-${hash}.${BOOK_TYPE}`)
  } catch (e) {
    notify('下载失败', e)
  }
}
